import { useMutation } from 'react-query';
import { httpService } from '../../../../../../services/http.service';
import { BASE_URL } from '../../../../../../constants/endpoints';
import { IServerErrorResponse } from '../../../../../../types';
import { flattenServerErrorResponse } from '../../../../../../helpers/errors.helper';

interface IPasswordRecoveryValidateBody {
    loginName: string
    ssn: string
}
export const usePasswordRecoveryValidate = (onError: (code: number, msg: string) => void) => useMutation(
  'usePasswordRecoveryValidate',
  async ({
    loginName,
    ssn,
  }: IPasswordRecoveryValidateBody) => {
    const res = await httpService.post(`${BASE_URL}/api/v2/user/openauth/recovery/validate`, { loginName, ssn });
    return res.data;
  },
  {
    retry: 0,
    onError: (e:IServerErrorResponse) => {
      const { localizedMessage, code } = flattenServerErrorResponse(e);
      onError(code, localizedMessage);
    },
  },
);
interface IPasswordRecoveryStartBody {
    loginName: string
    mfaType: string
}
export const usePasswordRecoveryStart = (customerId: string, onError: (code: number, msg: string) => void) => useMutation(
  'usePasswordRecoveryStart',
  async ({
    loginName,
    mfaType,
  }: IPasswordRecoveryStartBody) => {
    const res = await httpService.post(`${BASE_URL}/api/v2/user/openauth/${customerId}/recovery/start`, { loginName, mfaType });
    return res.data;
  },
  {
    retry: 0,
    onError: (e:IServerErrorResponse) => {
      const { localizedMessage, code } = flattenServerErrorResponse(e);
      onError(code, localizedMessage);
    },
  },
);
export interface IPasswordRecoveryChallengeBody {
    answer: string
    rememberMe: boolean
    clientId: string
    mfaType: string
}
export const usePasswordRecoveryChallenge = (customerId: string, onError: (code: number) => void) => useMutation(
  'usePasswordRecoveryChallenge',
  async ({
    answer,
    rememberMe,
    clientId,
    mfaType,
  }: IPasswordRecoveryChallengeBody) => {
    console.log(`usePasswordRecoveryChallenge - ${customerId}`);

    const res = await httpService.post(
      `${BASE_URL}/api/v2/user/openauth/${customerId}/recovery/pin`,
      {
        answer, rememberMe, clientId, mfaType,
      },
    );
    return res.data;
  },
  {
    retry: 0,
    onError: (e:IServerErrorResponse) => {
      const { code } = flattenServerErrorResponse(e);
      onError(code);
    },
  },
);
interface IPasswordRecoveryPasswordBody {
    token: string
    setPasswordData: any
}
export const usePasswordRecoveryPassword = (customerId: string, onError: (code: number, msg: string) => void) => useMutation(
  'usePasswordRecoveryPassword',
  async ({
    token,
    setPasswordData,
  }: IPasswordRecoveryPasswordBody) => {
    const res = await httpService.post(`${BASE_URL}/api/v1/user/openauth/${customerId}/recovery/password`, {
      token, setPasswordData,
    });
    return res.data;
  },
  {
    retry: 0,
    onError: (e:IServerErrorResponse) => {
      const { code, localizedMessage } = flattenServerErrorResponse(e);
      onError(code, localizedMessage);
    },
  },
);
